import { render, staticRenderFns } from "./CostumerList.vue?vue&type=template&id=14932b7e"
import script from "./CostumerList.vue?vue&type=script&lang=js"
export * from "./CostumerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports